import CrudPage from "@/components/admin/CrudPage";

const FIELDS = [
  { key: "name", label: "Service name (display name)" },
  { key: "category", label: "Category" },
  { key: "short_description", label: "Short description (card copy)", type: "textarea", rows: 2, span: "full" },
  { key: "full_description", label: "Full description", type: "textarea", rows: 3, span: "full" },
  { key: "price_range", label: "Price range" },
  {
    key: "learn_more_url", label: "Learn More URL (service page)", type: "internal_link", exclude: ["/request-estimate"],
    help: "Card title and Learn More button link here. Choose the matching service page.",
  },
  {
    key: "estimate_cta_url", label: "Estimate CTA URL", type: "internal_link", allowEmpty: false, defaultValue: "/request-estimate",
    help: "Usually Request Estimate (/request-estimate).",
  },
  { key: "quote_required", label: "Quote required", type: "checkbox" },
  { key: "active", label: "Active (show this card on the website)", type: "checkbox" },
  { key: "sort_order", label: "Sort order", type: "number" },
];

const BLANK = {
  name: "", category: "general", short_description: "", full_description: "",
  price_range: "", learn_more_url: "", estimate_cta_url: "/request-estimate", quote_required: false, active: true, sort_order: 99,
};

export default function AdminServices() {
  return (
    <CrudPage
      resource="services"
      title="Services"
      description="Add, edit, hide, or remove services. Public website pulls from this list."
      fields={FIELDS}
      blank={BLANK}
      testIdPrefix="services"
    />
  );
}
